import { Reference } from "@apollo/client";

import useMutationWithValidation from "@hooks/useMutationWithValidation";
import {
  ArticleBasicFragmentDoc,
  EmployerBenefitFragmentDoc,
  GoalFragment,
  GoalItemCreateDocument,
  GoalItemCreateMutation,
  GoalItemCreateMutationVariables
} from "@typing/Generated";

const useCreateGoalItem = (goal: GoalFragment | null) => {
  const [createGoalItem] = useMutationWithValidation<GoalItemCreateMutation, GoalItemCreateMutationVariables>(
    GoalItemCreateDocument,
    "goal",
    {
      update: (store, { data }) => {
        if (data?.goalItemCreate?.article) {
          store.modify({
            fields: {
              articles(cachedArticleRefs: readonly Reference[]): Reference[] {
                const newArticleRef = store.writeFragment({
                  data: data.goalItemCreate?.article,
                  fragment: ArticleBasicFragmentDoc,
                  fragmentName: "ArticleBasic"
                });
                if (newArticleRef && data.goalItemCreate?.article) {
                  return [...cachedArticleRefs, newArticleRef];
                }
                return [...cachedArticleRefs];
              }
            },
            id: store.identify({ ...goal })
          });
        }

        if (data?.goalItemCreate?.employerBenefit) {
          store.modify({
            fields: {
              employerBenefits(cachedEmployerBenefitRefs: readonly Reference[]) {
                const newEmployerBenefitRef = store.writeFragment({
                  data: data.goalItemCreate?.employerBenefit,
                  fragment: EmployerBenefitFragmentDoc,
                  fragmentName: "EmployerBenefit"
                });
                if (newEmployerBenefitRef && data.goalItemCreate?.employerBenefit) {
                  return [...cachedEmployerBenefitRefs, newEmployerBenefitRef];
                }
                return [...cachedEmployerBenefitRefs];
              }
            },
            id: store.identify({ ...goal })
          });
        }

        if (data?.goalItemCreate?.tools) {
          store.modify({
            fields: {
              tools() {
                return data.goalItemCreate?.tools ?? null;
              }
            },
            id: store.identify({ ...goal })
          });
        }
      }
    }
  );

  return createGoalItem;
};

export default useCreateGoalItem;
